import { CreditCard } from "@/api/credit-cards/credit-cards";
import { Button } from "@/components/ui/button/button";
import { AVS_REAUTH_MESSAGE } from "@/constants/avs-reauth";
import { Link, useNavigate } from "@tanstack/react-router";
import { PlusIcon, ShieldAlert } from "lucide-react";
import PaymentCard from "../../ui/paymentCard";

interface CardViewProps {
	creditCards: CreditCard[];
}

const SelectDeposit: React.FC<CardViewProps> = ({ creditCards: cardList }) => {
	const navigate = useNavigate();

	return (
		<div className="">
			<p className=" font-medium text-center text-textDark">
				Select a card to start converting your
			</p>
			<p className=" font-medium text-center text-textDark">
				available credit limit into spendable cash.
			</p>

			<output
				aria-live="polite"
				className="mt-6 block w-full rounded-lg border border-amber-300 bg-amber-50 p-3 text-left text-amber-900"
				data-testid="avs-reauth-notice"
			>
				<div className="flex items-start gap-2">
					<ShieldAlert
						className="mt-0.5 h-5 w-5 shrink-0 text-amber-600"
						aria-hidden="true"
					/>
					<p className="flex-1 text-sm">{AVS_REAUTH_MESSAGE}</p>
				</div>
			</output>

			<div className="bg-primary-50 rounded-3xl py-6 px-7 mt-6">
				<div className="flex items-center justify-between mb-4">
					<h2 className="text-lg font-bold text-textDark">My Cards</h2>
					<Button
						variant={"link"}
						size={"compact"}
						className="text-sm font-medium space-x-2 text-textDark"
						onClick={() =>
							navigate({
								to: "/main/card/new",
							})
						}
					>
						<PlusIcon /> <span>Add Card</span>
					</Button>
				</div>
				<div className="space-y-3 ">
					{cardList.map((card) => (
						<Link
							className="block w-full"
							key={card.id}
							data-testid={"select-deposit-card"}
							type="button"
							params={{ cardId: card.id.toString() }}
							to={"/main/deposit/$cardId/amount"}
						>
							<PaymentCard
								variant={"borderless"}
								card={card}
								shouldDisplayChevron={true}
							/>
						</Link>
					))}
				</div>
			</div>
		</div>
	);
};

export default SelectDeposit;
